import { LightningElement, api } from "lwc";

import type { CardSummary } from "../card/types";

export default class ContentCollectionCard extends LightningElement {
    static renderMode = "light";
    @api items: CardSummary[] = null!;
}
